<template>
  <ModalSelectOption
    v-model:show="uiStore.showThemePicker"
    :initial-value="currentTheme"
    :options="themeOptions"
    @confirm="onThemeSelected"
    @change="onThemeChange"
    @cancel="onThemeCancel"
    :z-index="2000"
  />
</template>

<script setup lang="ts">
import { useUI } from "@/stores/ui";
import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const uiStore = useUI();

const themeOptions = [
  "auto",
  "light",
  "dark",
  "cupcake",
  "bumblebee",
  "emerald",
  "corporate",
  "synthwave",
  "retro",
  "cyberpunk",
  "valentine",
  "halloween",
  "garden",
  "forest",
  "aqua",
  "lofi",
  "pastel",
  "fantasy",
  "wireframe",
  "black",
  "luxury",
  "dracula",
  "cmyk",
  "autumn",
  "business",
  "acid",
  "lemonade",
  "night",
  "coffee",
  "winter",
  // "dim",
  // "nord",
  // "sunset",
].map((v) => ({
  text: t(`SidebarNavi.themeMap.${v}`),
  value: v,
}));
const currentTheme = ref(localStorage.getItem("theme") || "light");

const onThemeSelected = (theme: string) => {
  onThemeChange(theme);
  localStorage.setItem("theme", theme);
  currentTheme.value = theme;
  uiStore.showThemePicker = false;
};

const onThemeChange = (theme: string) => {
  document.documentElement.setAttribute("data-theme", theme);
};

const onThemeCancel = () => {
  const savedTheme = localStorage.getItem("theme");
  if (savedTheme) onThemeChange(savedTheme);
  uiStore.showThemePicker = false;
};

watch(
  () => uiStore.showThemePicker,
  (v) => {
    if (v) {
      const savedTheme = localStorage.getItem("theme");
      if (savedTheme) onThemeChange(savedTheme);
    }
  }
);
</script>

<style scoped>
.theme-switcher {
  position: relative;
}

.theme-submenu {
  display: none;
  position: absolute;
  right: 0;
  top: 100%;
  margin-top: 0.25rem;
  z-index: 100;
  max-height: 400px;
  overflow-y: auto;
}

.theme-switcher:hover .theme-submenu {
  display: block;
}

/* Customize scrollbar */
.theme-submenu::-webkit-scrollbar {
  width: 4px;
}

.theme-submenu::-webkit-scrollbar-track {
  background: hsl(var(--b1));
  border-radius: 2px;
}

.theme-submenu::-webkit-scrollbar-thumb {
  background: hsl(var(--p) / 0.5);
  border-radius: 2px;
}

.theme-submenu::-webkit-scrollbar-thumb:hover {
  background: hsl(var(--p) / 0.8);
}
</style>
